import { GraphqlApi } from 'services/api';
import { snackBar } from './modelActions';
import { BUSINESS_MODEL, COUNTRY_LIST, FILTER_BY_STATUS, LOCK_STATUS_DASHBOARD, MODEL_AVAILABILITY, REGION_DROPDOWN, TOF_AUDIT_TRAIL, GET_PRODUCT_LINE, UPDATE_MODEL_AVAILABILITY, CREATE_EXISTING_AVAILABILITY, DELETE_MODEL_AVAILABILITY, DATA_TRANSPORT_AND_COMPLETE, MODULE_WISE, CATEGORY_FILTER, MATERIAL_AVAILABILITY_TABLE, DELETE_MATERIAL_AVAILABILITY, CREATE_AVAILABILITY, UPDATE_MATERIAL_AVAILABILITY, FACTORY_SERVICES_TABLE, MATERIAL_AVAILABILITY, MODEL_AVAILABILITY_TABLE, FACTORY_SERVICES, DASHBOARD_TITLE, DATA_TRANSPORT, COMPLETE, UPDATE_SERVICE_AVAILABILITY ,GET_OCPLC_CHOICES, DELETE_SERVICE, PARAMETERS_TABLE, LOCALIZATION_DEFAULT_TABLE, LOCALIZATION_AVAILABILITY_TABLE, PRODUCT_GROUP_DROPDOWN, LOC_AVAILABILITY, DEFAULT_LOC, UPLOAD_FILE, VERSION_0002, FILTER_OCPLC_KMAT_FOR_PG, UPLOAD_FILE_SUCCESS, UPLOAD_LAND_D_FILE, TOF_PROGRAM_MANAGEMENT_TABLE, DELETE_AVIALABLE_LOCALIZATION, DELETE_DEFAULT_LOCALIZATION, UPDATE_DEFAULT_LOCALIZATION, UPDATE_AVAILABILITY_LOCALIZATION, GET_DEFAULT_FEATURE_DROPDOWN, GET_DEFAULT_FEATURE_VALUE_DROPDOWN, CLEAR_OCPLC_DASHBOARD_FILTERS, CLEAR_OCPLC_FILTERS, TOF_PROGRAM_MANAGEMENT, DELETE_TOF_PROGRAM_MANAGEMENT, GET_PARAMETERS_DROPDOWN, UPDATE_TOF_PROGRAM_MANAGEMENT, LOCALIZATION_CHOICE_ID_TABLE, LOCALIZATION_MAPPING_TABLE, OCPLC_CONFIGURATION_TABLE, LOC_MAPPING, LOC_CHOICE_ID, DELETE_LOC_MAPPING, DELETE_LOC_CHOICEID, BULK_DT_MATERIAL_AVAILABILITY, GET_LOCALIZATION_CHOICE_KEY, UPDATE_LOC_CHOICEID, GET_LOCALIZATION_CHOICE_NAME, GET_LOCALIZATION_CHOICE_VALUE, GET_PARAMETERS_LOCALIZATION_DROPDOWN, UPDATE_LOC_MAPPING, LOAD_COUNT, LOAD_COUNT_DT, GET_REGIONAL_CHECKBOXES} from 'constants/ocplcConstants';
import { regionalFields } from 'pages/OcplcEditDashboard/OcplcEditColumns/columnTypes';
import { LOCAL_STORAGE_KEY, clearLocalStorageKey } from 'utils/localStorageUtil';
import fileDownload from 'js-file-download';
import { u8arrFromBase64EncodedString } from 'utils/string-utils';
import { extractAndJoin, moduleTypeMap } from 'pages/Utils/OcplcUtil';
import { queries } from 'services/Queries';

export const filterOcplcKmat = (productLineID) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query('getOcplcProductFamily', { filter: { productLine: productLineID } });
        dispatch({ type: "FILTER_KMAT", payload: res?.data?.ocplcKmatProductFamily?.productFamily })
    } catch (error) {
        dispatch({ type: "FILTER_KMAT", payload: [] })
        dispatch(snackBar(true, error.message, "error"));
    }
}
export const categoryFilter =(version, region,tableName) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query('categoryFilter', { filter: {version,region,tableName} });
        dispatch({ type: CATEGORY_FILTER, payload: res?.data?.ocplcCategory?.categories })
    } catch (error) {
        dispatch({ type: CATEGORY_FILTER, payload: [] })
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const refreshOcplc = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query('ocplcDashboard');
        const ocplcData = res?.data?.ocplcDashboard;
        dispatch({ type: "REFRESH_OCPLC", payload: ocplcData });
    } catch (error) {
        dispatch({ type: "REFRESH_OCPLC", payload: { ocplcData: [] } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const clearOcplcFilters = () => (dispatch) => {
    dispatch({ type: CLEAR_OCPLC_FILTERS });
}
export const clearOcplcDashboardFilters = () => (dispatch) => {
    dispatch({ type: CLEAR_OCPLC_DASHBOARD_FILTERS });
}

export const filterOcplc = (payload) => (dispatch) => {
    dispatch({ type: "FILTER_OCPLC", payload });
}

export const filterOcplcDashboard = (payload) => (dispatch) => {
    dispatch({ type: "FILTER_OCPLC_EDIT_DASHBOARD", payload });
}

export const filterByStatus = (payload) => (dispatch) => {
    dispatch({ type: FILTER_BY_STATUS, payload });
}

export const ocplcTableData = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query('ocplcTableDropDown');
        const tableData = res?.data?.ocplcTableDropDown.tables;
        dispatch({ type: "OCPLC_TABLE_DATA", payload: tableData });
    } catch (error) {
        dispatch({ type: "OCPLC_TABLE_DATA", payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const modelAvailability = (version, region, productFamily, productGroup, productLine, isLoading) => async (dispatch) => {
    try {
        isLoading && dispatch({ type: MODEL_AVAILABILITY, payload: { data: [], isLoading: isLoading } });
        const modelApi = region === "WW" ? "modelAvailability" : "otherRegional";
        const res = await GraphqlApi.query(modelApi, { version, region, productFamily, productGroup, productLine });

        const modelAvailability = res?.data?.[modelApi]?.models || [];
        dispatch({ type: MODEL_AVAILABILITY, payload: { data: modelAvailability, isLoading: false } });
    } catch (error) {
        dispatch({ type: MODEL_AVAILABILITY, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const materialAvailability = (version, region, productGroup, productFamily, category, startIndex, pageSize, sortColumn, dir, material, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: MATERIAL_AVAILABILITY_TABLE, payload: { data: [], isLoading: isLoading } });
        const params = { version, region, productGroup, productFamily, category, startIndex, pageSize, sortColumn, dir, material };
        const res = await GraphqlApi.query("materialAvailability", params);
        const materialData = res?.data?.materialAvailability;

        if (materialData?.isError) {
            dispatch({ type: MATERIAL_AVAILABILITY_TABLE, payload: { data: [], isLoading: false } });
            return dispatch(snackBar(true, materialData.response, "error"));
        }
        const data = region === "WW" ? materialData?.Materials || [] : materialData?.RegionView || [];
        dispatch({ type: MATERIAL_AVAILABILITY_TABLE, payload: { data, isLoading: false } });
    } catch (error) {
        dispatch({ type: MATERIAL_AVAILABILITY_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};


export const factoryService = (version, region, productGroup, productFamily, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: FACTORY_SERVICES_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("factoryServices", { filter: { version, region, productGroup, productFamily } });
        const factoryData = res?.data?.serviceAvailability;

        if (factoryData?.isError) {
            dispatch({ type: FACTORY_SERVICES_TABLE, payload: { data: [], isLoading: false } });
            dispatch(snackBar(true, factoryData.response, "error"));
            return;
        }

        const data = region === "WW" ? factoryData?.services || [] : factoryData?.RegionView || [];
        dispatch({ type: FACTORY_SERVICES_TABLE, payload: { data, isLoading: false } });
    } catch (error) {
        dispatch({ type: FACTORY_SERVICES_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const parameters = (version, region, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: PARAMETERS_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("getParameters", { filter: { version, region } });
        const parametersData = res?.data?.parameters?.params || [];
        dispatch({ type: PARAMETERS_TABLE, payload: { data: parametersData, isLoading: false } });
    } catch (error) {
        dispatch({ type: PARAMETERS_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const getTOFProgramManagement = (version, region, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: TOF_PROGRAM_MANAGEMENT_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("getTOFProgramManagement", { filter: { version, region } });
        const tofProgramData = res?.data?.tofProgramsManagement.tofManagement || [];
        dispatch({ type: TOF_PROGRAM_MANAGEMENT_TABLE, payload: { data: tofProgramData, isLoading: false } });
    } catch (error) {
        dispatch({ type: TOF_PROGRAM_MANAGEMENT_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const getLocalizationMapping = (version, region, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: LOCALIZATION_MAPPING_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("getLocalizationMapping", { filter: { version, region } });
        const localizationMappingData = res?.data?.parameterLocalization?.localizationParameter || [];
        dispatch({ type: LOCALIZATION_MAPPING_TABLE, payload: { data: localizationMappingData, isLoading: false } });
    } catch (error) {
        dispatch({ type: LOCALIZATION_MAPPING_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const getLocalizationChoiceId = (version, region, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: LOCALIZATION_CHOICE_ID_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("getLocalizationChoiceId", { filter: { version, region} });
        const localizationChoiceIdData = res?.data?.parameterLocalizationChoice?.localizationChoiceParameter || [];
        dispatch({ type: LOCALIZATION_CHOICE_ID_TABLE, payload: { data: localizationChoiceIdData, isLoading: false } });
    } catch (error) {
        dispatch({ type: LOCALIZATION_CHOICE_ID_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const getOcplcConfiguration = (version, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: OCPLC_CONFIGURATION_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("getOcplcConfiguration", { filter: { version } });
        const ocplcConfigurationData = res?.data?.parameterConfiguration?.parameterConfiguration || [];
        dispatch({ type: OCPLC_CONFIGURATION_TABLE, payload: { data: ocplcConfigurationData, isLoading: false } });
    } catch (error) {
        dispatch({ type: OCPLC_CONFIGURATION_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};
export const saveOcplcConfiguration = (inputData) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("saveOcplcConfiguration", inputData);
        const message = res.data.updateParameterConfiguration.message;
        const response = res.data.updateParameterConfiguration.response;
        if (response === "Success") {
            dispatch(snackBar(true, message, "success"));
        }
    } catch (error) {
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const localizationDefault = (version, region, bussGroup, productGroup, productFamily, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: LOCALIZATION_DEFAULT_TABLE, payload: { data: [], isLoading } });
        const res = await GraphqlApi.query("getLocalizationDefault", { filter: { version, region, bussGroup, productGroup, productFamily } });
        const localizationDefaultData = res?.data?.localizationDefault?.localizationDefault || [];
        dispatch({ type: LOCALIZATION_DEFAULT_TABLE, payload: { data: localizationDefaultData, isLoading: false } });
    } catch (error) {
        dispatch({ type: LOCALIZATION_DEFAULT_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const localizationAvailability = (version, region, productFamily, productGroup, isLoading) => async (dispatch) => {
    try {
        dispatch({ type: LOCALIZATION_AVAILABILITY_TABLE, payload: { data: [], isLoading } });
        const apiMethod = region === "WW" ? "getLocalizationAvailability" : "getRegionsLOCAvailability";
        const res = await GraphqlApi.query(apiMethod, { filter: { version, region, productFamily, productGroup } });
        const data = region === "WW" ? res?.data?.localizationAvailability?.localizations || [] : res?.data?.RegionallocalizationAvailability?.localizations || [];
        dispatch({ type: LOCALIZATION_AVAILABILITY_TABLE, payload: { data, isLoading: false } });
    } catch (error) {
        dispatch({ type: LOCALIZATION_AVAILABILITY_TABLE, payload: { data: [], isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const OcplcKmatLockingQuery = (kmatId, isPLCAdmin, loginUserEmailId, lastModifiedTime, status, isBack = false) => async (dispatch) => {
    const kmatInArray = [].concat(kmatId);
    try {
        const res = await GraphqlApi.query("OcplcKmatLockingQuery", {
            kmatId: kmatInArray,
            isAdmin: isPLCAdmin,
            loginUserEmailId: loginUserEmailId,
            lastModifiedTime: lastModifiedTime,
            status: status,
            isBack: isBack,
        });

        const lockStatus = res.data.ocplcKmatLocking;
        dispatch({ type: LOCK_STATUS_DASHBOARD, payload: lockStatus });
        return lockStatus.isError;

    } catch (error) {
        dispatch({ type: LOCK_STATUS_DASHBOARD, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const countryList = (region) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("ocplcCountryDropDown", { filter: { region: region } });
        const countryList = res?.data?.ocplcCountryDropDown?.countries || [];
        dispatch({ type: COUNTRY_LIST, payload: countryList });
    } catch (error) {
        dispatch({ type: COUNTRY_LIST, payload: { countryList: [] } });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const productGroupDropDown = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("GetOcplcProductGroupDropDown");
        const productGroups = res?.data?.oplcProductGroupDropDown?.ocplcProductGroups || [];
        dispatch({ type: PRODUCT_GROUP_DROPDOWN, payload: productGroups });
    } catch (error) {
        dispatch({ type: PRODUCT_GROUP_DROPDOWN, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}


export const getRegionalWWDates = (productFamily, productGroup, country, businessModel) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getRegionalWWDates", {
            filter: { productFamily, productGroup, country, businessModel }
        });
        const regionalWWDates = res?.data?.getRegionalWWDates || {};
        return regionalWWDates
    } catch (error) {
        dispatch(snackBar(true, error.message, "error"));
        return {}
    }
};

export const getOcplcBusinessModels = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getOcplcBusinessModel")
        const businessModels = res?.data?.ocplcBusinessModel?.businessModels || [];
        dispatch({ type: BUSINESS_MODEL, payload: businessModels });
    } catch (error) {
        dispatch({ type: BUSINESS_MODEL, payload: error.message });
    }
};

export const ocplcRegionDropDown = (role) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("ocplcRegionDropDown", {
            filter: { role: role }
        });
        const regions = res?.data?.ocplcRegionDropDown?.regions || [];
        dispatch({ type: REGION_DROPDOWN, payload: regions });
    } catch (error) {
        dispatch({ type: REGION_DROPDOWN, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const deleteAction = ({ pkId, comments, whoChanged, productFamily, handleClose, country, region, selectedTable, setCheckedRows, setSelectedIds}) => async (dispatch) => {
        const isMaterialAvailability = selectedTable === 'Material Availability';
        const isModelAvailability = selectedTable === 'Model Availability';
        const isServices = selectedTable === 'Factory Services';
        const isTOFPM = selectedTable === TOF_PROGRAM_MANAGEMENT;
        const isAvaliableLocalization = selectedTable === LOC_AVAILABILITY;
        const isDefaultLocalization = selectedTable === DEFAULT_LOC;
        const isParametersLocation = selectedTable === LOC_MAPPING || selectedTable === LOC_CHOICE_ID;
        const isLocChoiceId = selectedTable === LOC_CHOICE_ID;
        const apiMethod = isMaterialAvailability ? "deleteMaterialAvailability" : isModelAvailability ? "deleteModelAvailability" : isServices?"deleteServiceAvailability": isAvaliableLocalization ? "deleteLocalizationAvailability" : isDefaultLocalization ? "deleteDefaultLocal" : isTOFPM ? "deleteParameter" : "deleteParametersLocalization";
        const actionType = isMaterialAvailability ? DELETE_MATERIAL_AVAILABILITY : isModelAvailability ? DELETE_MODEL_AVAILABILITY : isServices ? DELETE_SERVICE : isAvaliableLocalization ? DELETE_AVIALABLE_LOCALIZATION : isDefaultLocalization ? DELETE_DEFAULT_LOCALIZATION : isTOFPM ? DELETE_TOF_PROGRAM_MANAGEMENT : isLocChoiceId ? DELETE_LOC_CHOICEID : DELETE_LOC_MAPPING;
        const data = isModelAvailability || isTOFPM || isAvaliableLocalization || isParametersLocation ? { pkId, comments, whoChanged } : { pkId };
        try {
            dispatch({ type: actionType, payload:{ pkId:null, isLoading:true} });
            handleClose();
            const res = await GraphqlApi.query(apiMethod, { input: data });
            const message = res.data[apiMethod].message;

            const successMessage = `${isMaterialAvailability ? 'Material' : isModelAvailability ? 'Model' : isServices ? 'Service' : isAvaliableLocalization ? 'Localization' : isDefaultLocalization? 'Default Localization' : isTOFPM? 'TOF Program' : isLocChoiceId ? 'Localization Choice ID' : 'Localization Mapping'} ${!(isTOFPM || isParametersLocation) ? 'availability' : ''} ${isLocChoiceId ? 'assignment deleted successfully.' : `for ${productFamily} has been removed for Region: ${region} ${!(isTOFPM || isParametersLocation )? ` | Country: ${country}` : ''}`}`;
        if (message === 'Success' || message === 'Records deleted successfully.' || message === 'Selected record deleted successfully') {           
            dispatch({ type: actionType, payload:{...data ,isLoading:false} });
            dispatch(snackBar(true, successMessage, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setCheckedRows([]);
            setSelectedIds([]);
        } else {
            dispatch({ type: actionType, payload:{ pkId:null, isLoading:false} });
            dispatch(snackBar(true, message, 'error'));
        }
    } catch (error) {
        dispatch({ type: actionType, payload:{ pkId:null, isLoading:false} });
        dispatch(snackBar(true, error.message, "error"));
    }
};


export const ocplcgetTOFAuditTrial = (feedType, row) => async (dispatch) => {
    const apiMethodsMapping = {
        modelTargetOfferAudit: { apiMethod: "ocplcModelTOFAuditTrial", fetchApiMethodData: "modelTOFAuditTrial" },
        modelOfferAudit: { apiMethod: "ocplcModelAvailabilityAuditTrial", fetchApiMethodData: "modelAuditTrial" },
        modelTargetOfferAuditV3: { apiMethod: "ocplcModelTOFAuditTrialVersion", fetchApiMethodData: "modelTOFAuditTrial" },
        modelOfferAuditV3: { apiMethod: "ocplcModelAvailabilityAuditTrialVersion", fetchApiMethodData: "modelAuditTrial" },
        materialTargetOfferAudit: { apiMethod: "materialAvailabilityTOFAudit", fetchApiMethodData: "tof" },
        materialOfferAuditV2: { apiMethod: "materialAvailabilityAudit", fetchApiMethodData: "material" },
        materialAvailabilityAuditV3: { apiMethod: "materialAvailabilityAuditV2", fetchApiMethodData: "material" },
        serviceOfferAudit: { apiMethod: "serviceAvailabilityAudit", fetchApiMethodData: "services" },
        serviceAvailabilityAuditV3: { apiMethod: "servicesAuditV3", fetchApiMethodData: "V3resp" },
        tofProgramManagement:{apiMethod:"parametersAudit",fetchApiMethodData:"paramaterAudits"},
        defaultLocAudit:{apiMethod:"localizationDefaultAudit",fetchApiMethodData:"defaultLocAudit"},
        avilableLocAudit:{apiMethod:"localizationAvailabilityAudit",fetchApiMethodData:"localizations"},
    };
    const { apiMethod, fetchApiMethodData } = apiMethodsMapping[feedType]
    const data = feedType === "tofProgramManagement" || feedType === "defaultLocAudit"
    ? {
        pkId: row.pkId,
        version: row.version
    }
    :["modelOfferAuditV3", "modelTargetOfferAuditV3","materialAvailabilityAuditV3","serviceAvailabilityAuditV3"].includes(feedType)
        ? {
            region: row.region,
            productGroup: row.productGroup,
            productFamily: row.productFamily,
            businessModel: row.businessModel,
            country: row.country,
            ...(["serviceAvailabilityAuditV3", "materialAvailabilityAuditV3"].includes(feedType) && { material: row.material })
        }
        : { pkId: feedType === "modelTargetOfferAudit" ? row.tofPkIds : row.pkId };

    try {
        dispatch({ type: TOF_AUDIT_TRAIL, payload: {modelAuditTrial:[],isLoading:true} });
        const res = await GraphqlApi.query(apiMethod, {
            filter: data
        });
        const modelAuditTrial = res?.data?.[apiMethod]?.[fetchApiMethodData] || [];
        dispatch({ type: TOF_AUDIT_TRAIL, payload: {modelAuditTrial,isLoading:false} });
    } catch (error) {
        dispatch({ type: TOF_AUDIT_TRAIL, payload: {modelAuditTrial:[],isLoading:false} });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const updateModelAvailability = (formData, plcDetails, userEmail, isOtherRegion, regionForCopyAndEdit, copy, kmatId, productLineID, selectedTableRegion, handleClose, setCheckedRows, isWwStartDateEdited, isWwEndDateEdited, isRegStartDateEdited, isRegEndDateEdited, setSelectedIds) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    // Base common fields
    let data = {
        pkId: copy ? "0" : plcDetails.pkId,
        version: plcDetails.version,
        region: regionForCopyAndEdit,
        productDesc: plcDetails.productDesc,
        productGroup: plcDetails.productGroup,
        productFamily: copy ? formData.productFamily : plcDetails.productFamily,
        status: copy ? formData.status : plcDetails.status,
        whoChanged: userEmail,
        copy: copy
    };
    // Fields specific to "WW" region
    if (!isOtherRegion) {
        data = {
            ...data,
            country: formData["countryID"],
            businessModel: formData["businessModel"],
            comments: formData["comment"],
            apRegion: formData["ap"],
            euRegion: formData["eu"],
            naRegion: formData["na"],
            laRegion: formData["la"],
            ms4StartDate: plcDetails.ms4StartDate,
            ms4EndDate: plcDetails.ms4EndDate,
            startDate: formData["startDate"] && formData["startDate"]?.format() || "",
            endDate: formData["endDate"] && formData["endDate"]?.format() || "",
            hStartDate: "",
            hEndDate: "",
            visibleDate: "",
            countryDesc: formData["countryDesc"],
            isStartDtEdited: isWwStartDateEdited,
            isEndDtEdited: isWwEndDateEdited
        };
    }
    // Fields specific to other regions
    else {
        data = {
            ...data,
            country: formData["countryID"] || "",
            countryDesc: formData["countryDesc"] || "",
            businessModel: formData["businessModel"] || "",
            comments: formData["comment"] || "",
            wwStartDate: formData["wwStartDate"]?.format() || "",
            wwEndDate: formData["wwEndDate"]?.format() || "",
            startDate: formData["regStartDate"] && formData["regStartDate"]?.format() || "",
            endDate: formData["regEndDate"] && formData["regEndDate"]?.format() || "",
            isStartDtEdited: isRegStartDateEdited,
            isEndDtEdited: isRegEndDateEdited
        };
        // Add regional fields dynamically
        regionalFields.forEach(({ startField, startName, endField, endName }) => {
            data[startField] = formData[startField] && formData[startField]?.format() || "";
            data[endField] = formData[endField] && formData[endField]?.format() || "";
            data[startName] = plcDetails[startName];
            data[endName] = plcDetails[endName];
        });
    }
    try {
        const apiMethod = isOtherRegion ? "updateTofModelAvailability" : "updateModelAvailability";
        const res = await GraphqlApi.query(apiMethod, { input: data });

        if (res.data[apiMethod].message === "Success") {
            const { pkId, status, createDate, lastModifiedDate, startDate, endDate } = res.data[apiMethod];
            if (copy) {
                dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { ...data, pkId, status, createDate, lastModifiedDate, startDate, endDate, isLoading:false } });
                setSelectedIds([]);
                setCheckedRows([]);
            } else {
                dispatch({ type: UPDATE_MODEL_AVAILABILITY, payload: data });
                handleClose()
                dispatch(modelAvailability(plcDetails.version, selectedTableRegion, kmatId, plcDetails.productGroup, productLineID, true));
            }
            dispatch(snackBar(true, `Model data for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
        }
    } catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}});
        }
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const updateMaterialAvailability = (formData, plcDetails, userEmail, handleClose, setCheckedRows, selectedCategory, selectedTableRegion, kmatId, productGroupDashboard) => async (dispatch) => {
    const { pkId, version, region, productGroup, productFamily, material, materialDesc, choiceId, regionLock, businessGroup } = plcDetails;
    let editMaterialObj = {
        pkId: pkId,
        version: version,
        region: region,
        country: formData["countryID"],
        countryDesc: formData["countryDesc"],
        businessGroup: businessGroup,
        businessModel: formData["businessModel"],
        productGroup: productGroup,
        productFamily: productFamily,
        sltdProductFamily: kmatId,
        material: material,
        materialDesc: materialDesc,
        localization: formData["localization"],
        choiceId: choiceId,
        apRegion: formData["ap"] || false,
        euRegion: formData["eu"] || false,
        naRegion: formData["na"] || false,
        laRegion: formData["la"] || false,
        autoStartDate: formData["autoStartDate"]?.format() || "",
        autoEndDate: formData["autoEndDate"]?.format() || "",
        startDate: region === "WW" ? formData["startDate"] && formData["startDate"]?.format() : formData["regStartDate"] && formData["regStartDate"]?.format() || "",
        endDate: region === "WW" ? formData["endDate"] && formData["endDate"]?.format() : formData["regEndDate"] && formData["regEndDate"]?.format() || "",
        startFlag: "",
        endFlag: "",
        hStartDate: "",
        hEndDate: "",
        comments: formData["comment"],
        status: formData["status"],
        regionLock: formData["regionalLock"],
        logicalLock: 0,
        whoChanged: userEmail,
        lastModifiedDate: "",
        createDate: "",
        keyOrder: 0,
        errorFlag: "",
        tofWhoChanged: "",
        tofWhenChanged: "",
        wwStartDate: formData["wwStartDate"]?.format() || "",
        wwEndDate: formData["wwEndDate"]?.format() || "", 
    };
    let data = {
        Editmaterial: [
            editMaterialObj
        ]
    };
    regionalFields.forEach(({ startField, startName, endField, endName }) => {
        editMaterialObj[startName] = plcDetails[startName];
        editMaterialObj[endName] = plcDetails[endName];
        editMaterialObj[startField] = formData[startField] && formData[startField]?.format() || "";
        editMaterialObj[endField] = formData[endField] && formData[endField]?.format() || "";
    });
    
    try {
        const res = await GraphqlApi.query("updateMaterialAvailability", {
            input: data
        });
        if (res.data.editMaterialAvailability.message === "Success") {
            dispatch({ type: UPDATE_MATERIAL_AVAILABILITY, payload: data.Editmaterial[0] });
            dispatch(materialAvailability(plcDetails.version, selectedTableRegion, productGroupDashboard, kmatId, selectedCategory, 0, 9999, "", "", "", true));
            dispatch(snackBar(true, `Material data for ${plcDetails.productFamily} updated successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            handleClose();
            setCheckedRows([]);
        }
    }
    catch (error) {
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const updateServiceAvailability = (formData, plcDetails, userEmail, handleClose, setCheckedRows, productLineID, copy, productGroupDashboard, kmatId,setSelectedIds) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    const { pkId, version, region, productGroup, productFamily, material, materialDesc, businessGroup } = plcDetails;

    let editServiceObj = {
        pkId: copy ? 0 : pkId,
        version: version,
        region: region,
        country: formData["countryID"] || "",
        countryDesc: formData["countryDesc"] || "",
        businessGroup: businessGroup,
        businessModel: formData["businessModel"],
        productGroup: productGroup,
        productFamily: productFamily,
        sltdProductFamily: kmatId,
        productLine: productLineID,
        material: material,
        materialDesc: materialDesc,
        choiceId: formData["choiceId"] || "",
        localization: formData["localization"] || "ALL",
        regionLock: false,
        businessGroup: "ALL",
        productDesc: "",
        apRegion: formData["ap"] || false,
        euRegion: formData["eu"] || false,
        naRegion: formData["na"] || false,
        laRegion: formData["la"] || false,
        startDate: formData["regAutoStartDate"] && formData["regAutoStartDate"]?.format() || "",
        endDate: formData["regAutoEndDate"] && formData["regAutoEndDate"]?.format() || "",
        wwAutoStartDate: formData["wwAutoStartDate"]?.format() || "",
        wwAutoEndDate: formData["wwAutoEndDate"]?.format() || "",
        comments: formData["comment"] || "",
        whoChanged: userEmail,
        copy: copy ? true : false
    };

    try {
        const res = await GraphqlApi.query("createServiceAvailability", {
            input: editServiceObj
        });
        const response = res?.data?.createServiceAvailability;
       if (response.message === "Success") {
    if (copy) {
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false} });
        setSelectedIds([]);
        setCheckedRows([]);
    } else {
        dispatch({ type: UPDATE_SERVICE_AVAILABILITY, payload: response });
        handleClose()
        dispatch(factoryService(version, region, productGroupDashboard, productFamily, true));
    }
    dispatch(snackBar(true, `Service data for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
    clearLocalStorageKey(LOCAL_STORAGE_KEY);
    }
    }
    catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}});
        }
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const updateDefaultLocalization = (formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, kmatId, setSelectedIds ) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    const {pkId, version, region, productGroup, productFamily, businessGroup } = plcDetails;
    let data = {
        pkId: copy ? 0: pkId,
        version: version,
        region: region,
        businessGroup: "",
        productGroup: productGroup || "",
        productFamily: productFamily,
        feature: formData["feature"] || "",
        featureValue: formData["featureValue"] || "",
        LocFeature: formData["locFeature"] || "",
        LocFeatureValue: formData["locFeatureValue"] || "",
        country: formData["countryID"] || "",
        comments: formData["comment"],
        status: copy ? formData.status : plcDetails.status, 
        productDesc: formData["productDesc"] || "",    
        whoChanged: userEmail, 
        
    };
    try {
        const res = await GraphqlApi.query("createDefaultLoc", { input: data });
        const response = res?.data?.createDefaultLoc;
        if (response.message === "Success") {
            if (copy) {
                dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false} });
                setCheckedRows([]);
                setSelectedIds([]);
            } else {
                dispatch({ type: UPDATE_DEFAULT_LOCALIZATION, payload: response });
                handleClose();
                dispatch(localizationDefault(version, region, "", productGroup, kmatId, true));
            }
            dispatch(snackBar(true, `Default localization for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
        }
    } catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}});
        }
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const updateAvailabilityLocalization = (formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, isOtherRegion, regionForCopyAndEdit, kmatId, setSelectedIds) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    const { pkId, version, region, productGroup, productFamily } = plcDetails;
    const apiMethod = isOtherRegion ? "copyRegionalLocalization" : "createLocalizationAvailability";
    let data = {
        pkId: copy ? 0 : pkId,
        version: version,
        region: regionForCopyAndEdit,
        productGroup: productGroup || "",
        productFamily: copy ? formData["productFamily"] || "" : productFamily,
        category: formData["category"] || "",
        productDesc: formData["productDesc"] || "",
        feature:  formData["feature"] || "",
        featureValue: formData["featureValue"] || "",
        featureDesc: formData["featureDesc"] || "",
        country: formData["countryID"] || "",
        countryDesc: formData["countryDesc"] || "",
        comments: formData["comment"],
        whoChanged: userEmail,
    };
 
    if(!isOtherRegion){
        data = {
            ...data,
            startDate: formData["startDate"]?.format() || "",
            endDate: formData["endDate"]?.format() || "",
            // status: copy ? formData.status : plcDetails.status,
            apRegion: formData["ap"] || false,
            euRegion: formData["eu"] || false,
            naRegion: formData["na"] || false,
            laRegion: formData["la"] || false,
        }
    }
    else {
        data = {
            ...data,
            wwStartDate: formData["wwStartDate"]?.format() || "",
            wwEndDate: formData["wwEndDate"]?.format() || "",
            regStartDate: formData["regStartDate"]?.format() || "",
            regEndDate: formData["regEndDate"]?.format() || "",
        }
    }
 
    try {
        const res = await GraphqlApi.query(apiMethod, { input: data });
        const response = res?.data[apiMethod];
        if (response.message === "Success") {
            if (copy) {
                dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false} });
                setCheckedRows([]);
                setSelectedIds([]);
            } else {
                dispatch({ type: UPDATE_AVAILABILITY_LOCALIZATION, payload: response });
                handleClose();
                dispatch(localizationAvailability(version, regionForCopyAndEdit, kmatId, productGroup, true));
            }
            dispatch(snackBar(true, `Available localization for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setCheckedRows([]);
        }
    } catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}});
        }
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const updateTOFProgramManagement = (formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, setSelectedIds) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    const { pkId, version, region, productGroup, productFamily } = plcDetails;
    let data = {
        pkId: copy ? 0 : pkId,
        version: version,
        region: region,
        productGroup: productGroup || "",
        productFamily: productFamily,
        parameterKey: formData["parameter"] || "",
        parameterValue: formData["parameterValue"] || "",
        parameterText: formData["parameterText"] || "",
        comments: formData["comment"],
        whoChanged: userEmail,
    };

    try {
        const res = await GraphqlApi.query("createTofProgramsManagement", { input: data });
        const response = res?.data?.createTofProgramsManagement;
        if (response.message === "Success") {
            if (copy) {
                dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false} });
                setCheckedRows([]);
                setSelectedIds([]);
            } else {
                dispatch({ type: UPDATE_TOF_PROGRAM_MANAGEMENT, payload: response });
                handleClose();
                dispatch(getTOFProgramManagement(version, region, true));
            }
            dispatch(snackBar(true, `TOF Program Management for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setCheckedRows([]);
        }
    } catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}})
        }
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const updateLocChoiceId = (formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, setSelectedIds) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    const { pkId, version, region, productGroup, productFamily } = plcDetails;
    let data = {
        pkId: copy ? 0 : pkId,
        version: version,
        region: region,
        productGroup: productGroup || "",
        productFamily: productFamily,
        parameterKey: formData["parameter"] || "",
        parameterValue: formData["parameterValue"] || "",
        parameterText: formData["parameterText"] || "",
        comments: formData["comment"],
        whoChanged: userEmail,
    };
    try {
        const res = await GraphqlApi.query("createLocalizationChoiceMapping", { input: data });
        const response = res?.data?.createLocalizationChoiceMapping;
        if (response.message === "Success") {
            if (copy) {
                dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false} });
                setCheckedRows([]);
                setSelectedIds([]);
            } else {
                dispatch({ type: UPDATE_LOC_CHOICEID, payload: response });
                handleClose();
                dispatch(getLocalizationChoiceId(version, region, true));
            }
            dispatch(snackBar(true, `Localization Choice ID for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
        }
    } catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}});
        }
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const updateLocMapping = (formData, plcDetails, userEmail, copy, handleClose, setCheckedRows, setSelectedIds) => async (dispatch) => {
    if(copy){
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload:{ pkId: null, isLoading: true } });
        handleClose();
    }
    const { pkId, version, region, productGroup, productFamily } = plcDetails;
    let data = {
        pkId: copy ? 0 : pkId,
        version: version,
        region: region,
        productGroup: productGroup || "",
        productFamily: productFamily,
        parameterKey: formData["parameter"] || "",
        parameterValue: formData["parameterValue"] || "",
        parameterText: formData["parameterText"] || "",
        comments: formData["comment"],
        whoChanged: userEmail,
    };
    try {
        const res = await GraphqlApi.query("createLocalizationMapping", { input: data });
        const response = res?.data?.createLocalizationMapping;
        if (response.message === "Success") {
            if (copy) {
                dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false} });
                setCheckedRows([]);
                setSelectedIds([]);
            } else {
                dispatch({ type: UPDATE_LOC_MAPPING, payload: response });
                handleClose();
                dispatch(getLocalizationMapping(version, region, true));
            }
            dispatch(snackBar(true, `Localization Mapping for ${plcDetails.productFamily} ${copy ? 'copied' : 'updated'} successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
        }
    } catch (error) {
        if(copy){
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId: null, isLoading: false}});
        }
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const GetDefaultFeatureDropDown = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getDefaultFeatureDropDown");
        const defaultFeatures = res?.data?.getDefaultFeatureDropDown?.featureDropDowns || [];
        dispatch({ type: GET_DEFAULT_FEATURE_DROPDOWN, payload: defaultFeatures });
    } catch (error) {
        dispatch({ type: GET_DEFAULT_FEATURE_DROPDOWN, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetParametersDropdown = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getLocalizationChoiceKey");
        const parameters = res?.data?.getLocalizationChoiceKey?.choice || [];
        dispatch({ type: GET_LOCALIZATION_CHOICE_KEY, payload: parameters });
    } catch (error) {
        dispatch({ type: GET_LOCALIZATION_CHOICE_KEY, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetLocChoiceName = (parameterKey, productGroupForParameter) => async (dispatch) => {
    
    try {
        const res = await GraphqlApi.query("getLocalizationChoiceName", { filter: { key: parameterKey, productGroup: productGroupForParameter } });
        const parameterName = res?.data?.getLocalizationChoiceName?.choice || "";
        dispatch({ type: GET_LOCALIZATION_CHOICE_NAME, payload: parameterName });
        return parameterName;
    } catch (error) {
        dispatch({ type: GET_LOCALIZATION_CHOICE_NAME, payload: "" });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetLocChoiceValue = (parameterKey, productGroupForParameter) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getLocalizationChoiceValue", { filter: { key: parameterKey, productGroup: productGroupForParameter } });
        const parameterValues = res?.data?.getLocalizationChoiceValue?.choice || [];
        dispatch({ type: GET_LOCALIZATION_CHOICE_VALUE, payload: parameterValues });
        return parameterValues;
    } catch (error) {
        dispatch({ type: GET_LOCALIZATION_CHOICE_VALUE, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetParametersLocDropdown = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getLocalizationMappingKey");
        const parameters = res?.data?.getLocalizationMappingKey?.mapping || [];
        dispatch({ type: GET_PARAMETERS_LOCALIZATION_DROPDOWN, payload: parameters });
    } catch (error) {
        dispatch({ type: GET_PARAMETERS_LOCALIZATION_DROPDOWN, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetDefaultFeatureValueDropDown = () => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getDefaultFeatureValueDropDown");
        const defaultFeatureValues = res?.data?.getDefaultFeatureValueDropDown?.value || [];
        dispatch({ type: GET_DEFAULT_FEATURE_VALUE_DROPDOWN, payload: defaultFeatureValues });
    }
    catch (error) {
        dispatch({ type: GET_DEFAULT_FEATURE_VALUE_DROPDOWN, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetParameters = (region, productGroup, productFamily) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getParameterKeys", { request: { region: region, productGroup: productGroup, productFamily: productFamily

         } });
        const parameters = res?.data?.getParameterKeys?.parameterKeys || [];
        dispatch({ type: GET_PARAMETERS_DROPDOWN, payload: parameters });
    }
    catch (error) {
        dispatch({ type: GET_PARAMETERS_DROPDOWN, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const GetProductLine = (productGroup) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("GetProductLine", { filter: { productGroup: productGroup } });
        const productLine = res?.data?.ocplcProductLine?.productLine || [];
        dispatch({ type: GET_PRODUCT_LINE, payload: productLine });
    } catch (error) {
        dispatch({ type: GET_PRODUCT_LINE, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const getOcplcChoices = (tabCategory, productFamily) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("getOcplcChoices", { filter: { tabCategory: tabCategory, productFamily: productFamily } });
        const choices = res?.data?.ocplcChoice?.choices || [];
        dispatch({ type: GET_OCPLC_CHOICES, payload: choices });
    } catch (error) {
        dispatch({ type: GET_OCPLC_CHOICES, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const loadCountForDT = (moduleName) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("GetDataTransportLoadCount", { moduleName });
        const loadCount = res?.data?.dataTransportLoadCount?.loadCount || 0;
        dispatch({ type: LOAD_COUNT_DT, payload: loadCount });
    } catch (error) {
        dispatch({ type: LOAD_COUNT_DT, payload: 0 });
        dispatch(snackBar(true, error.message, "error"));
    }
}

export const createAvailability = (formData, defaultproductLine, productLineID, onClose, setCheckedRows, isModelAvailabilty, isMaterialAvailability, isServiceAvailabilty, isDefaultLocalization, isTOFPM, isLocChoiceId, isLocMapping, kmatId, setSelectedIds,selectedCategory) => async (dispatch) => {
    dispatch({ type: CREATE_AVAILABILITY, payload: {createAvailability:null, isLoading: true} });
    onClose();
    const apiMethod = isMaterialAvailability ? "createMaterialAvailability" : isServiceAvailabilty ? "createServiceAvailability" : isDefaultLocalization ? "createDefaultLoc" : isTOFPM ? "createTofProgramsManagement" : isLocChoiceId ? "createLocalizationChoiceMapping" : isLocMapping ? "createLocalizationMapping" : "createModelAvailability";

    const data = {
        ...(isServiceAvailabilty ? {
            businessGroup: "ALL",
            productDesc: "",
            choiceId: formData.CHOICE_ID || "",
            localization: formData.LOCALIZATION || "",
            regionLock: false,
            startDate: formData.START_DATE.format() || "",
            endDate: formData.END_DATE.format() || "",
            wwAutoStartDate: formData.WW_AUTO_START_DATE?.format() || "",
            wwAutoEndDate: formData.WW_AUTO_END_DATE?.format() || "",
            material: formData.MATERIAL || "",
            materialDesc: "",
            countryDesc: "ALL",
            copy: false,
        } : {}),
        ...(isMaterialAvailability || isServiceAvailabilty ? { sltdProductFamily: kmatId } : {}),
        ...(isServiceAvailabilty || isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping ? {pkId: 0,} : {}),
        version: formData.VERSION,
        region: formData.REGION,
        ...(isTOFPM || isLocChoiceId || isLocMapping ? {} : { country: formData.COUNTRY }),
        ...(isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping ? {} : { businessModel: formData.BUSINESS_MODEL }),
        ...(!isDefaultLocalization ? { productLine: defaultproductLine } : {}),
        productGroup: formData.PRODUCT_GROUP,
        productFamily: formData.PRODUCT_FAMILY,
        ...(isServiceAvailabilty || isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping ? {} : {
            startDate: formData.START_DATE.format(),
            endDate: formData.END_DATE.format(),
        }),
        ...(isDefaultLocalization ? { productDesc: formData.PRODUCT_DESC } : {}),
        ...(isMaterialAvailability || isTOFPM || isLocChoiceId || isLocMapping ? {} : { productDesc: formData.PRODUCT_DESC }), // Exclude productDesc if isMaterialAvailability is true
        ...(isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping ? {} : {
            apRegion: formData.apRegion,
        euRegion: formData.euRegion,
        naRegion: formData.naRegion,
        laRegion: formData.laRegion,}),
        whoChanged: formData.whoChanged,
        comments: formData.COMMENT,
        ...(isMaterialAvailability && {
            material: formData.MATERIAL,
            choiceId: formData.CHOICE_ID || "",
            localization: formData.LOCALIZATION || "",
            regionLock: formData.REGIONAL_LOCK,
        }),
        ...(isDefaultLocalization && {
            businessGroup: formData.BUSINESS_GROUP || "",
            feature: formData.FEATURE || "",
            featureValue: formData.FEATURE_VALUE || "",
            LocFeature: formData.LOC_FEATURE || "",
            LocFeatureValue: formData.LOC_FEATURE_VALUE || "",
        }),
        ...((isTOFPM || isLocChoiceId || isLocMapping) && {
            parameterKey: formData.PARAMETER || "",
            parameterValue: formData.PARAMETER_VALUE || "",
            parameterText: formData.PARAMETER_NAME || "",
        }),
    };

    try {
        const res = await GraphqlApi.query(apiMethod, { input: data });

        const response = res?.data?.[apiMethod];

        if (response?.message === 'Success') {
            dispatch({ type: CREATE_AVAILABILITY, payload: {createAvailability:response,isLoading:false}});
            if (!(isDefaultLocalization || isTOFPM || isLocChoiceId || isLocMapping)) {
            dispatch(filterOcplcKmat(productLineID));
            }
            if(isMaterialAvailability && formData.REGIONAL_LOCK){
                dispatch(materialAvailability(formData.VERSION, formData.REGION, formData.PRODUCT_GROUP, kmatId, selectedCategory, 0, 9999, "", "", "", true));
            }
            dispatch(snackBar(true, `${isMaterialAvailability ? 'Material' : isServiceAvailabilty ? 'Service' :isDefaultLocalization? 'Default Localization' : isTOFPM ? 'TOF Program' : isLocChoiceId ? 'Localization Choice ID' : isLocMapping ? 'Localization Mapping' : 'Model'} data for ${response.productFamily} added successfully`, 'success'));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setCheckedRows([]);
            setSelectedIds([]);
        }
    } catch (error) {
        dispatch({ type: CREATE_AVAILABILITY, payload: {createAvailability:null,isLoading:false}});
        dispatch(snackBar(true, error.message, "error"));
    }
};


export const dataTransportAction = (actionType, pkIds, whoChanged, version, region, kmatId, selectedCategory ,productGroup, productLineID, selectedTable, selectedProductGroup, checkedRows) => async (dispatch) => {
        dispatch({ type: DATA_TRANSPORT_AND_COMPLETE, payload: { isLoading: true } });

    const isMaterial = selectedTable === MATERIAL_AVAILABILITY;
    const isModel = selectedTable === MODEL_AVAILABILITY_TABLE;
    const isServices = selectedTable === FACTORY_SERVICES;
    const isDefaultLOC = selectedTable === DEFAULT_LOC;
    const isLOCAvailability = selectedTable === LOC_AVAILABILITY;
    const isTOFPM = selectedTable === TOF_PROGRAM_MANAGEMENT;
    const isLOCmapping = selectedTable === LOC_MAPPING;
    const isLOCCID = selectedTable === LOC_CHOICE_ID;
    const isDataTransport = actionType === DATA_TRANSPORT;
    const isComplete = actionType === COMPLETE;

    const moduleType = moduleTypeMap[selectedTable] || '';

    // Version for Default Localization and Available Localization
    const usedVersion = (isDefaultLOC || isLOCAvailability || isTOFPM) ? VERSION_0002 : version;

    // Use selectedProductGroup for Default Localization and Available Localization, otherwise use productGroup
    const usedProductGroup = (isDefaultLOC || isLOCAvailability) ? selectedProductGroup : productGroup;

    let apiMethod = '';
    if (isDataTransport) {
        if (isMaterial) {
            const hasCheckedRows = checkedRows?.length !== 0;
            apiMethod = hasCheckedRows ? 'moduleWiseDataTransport' : 'materialBulkDataTransport';
        } else {
            apiMethod = 'moduleWiseDataTransport';
        }
    } else if (isComplete) {
        if (isMaterial) {
            apiMethod = 'completeMaterialAvailability';
        } else if (isServices) {
            apiMethod = 'completeServiceAvailability';
        } else if (isDefaultLOC) {
            apiMethod = 'completeDefaultLoc';
        } else if (isLOCAvailability) {
            apiMethod = 'completeLocalizationAvailability';   
        } else if (isTOFPM || isLOCmapping || isLOCCID) {
            apiMethod = 'completeParameter';    
        } else {
            apiMethod = 'completeModelAvailability';
        }
    }


    let apiParams = {};
    if (isDataTransport) {
        if (isMaterial) {
            const hasCheckedRows = checkedRows?.length !== 0;
             if (hasCheckedRows) {
                apiParams = { filter: { pkIds, whoChanged, moduleType, productFamily: kmatId  } };
              } else {
                apiParams = { filter: {
                        whoChanged,
                        version: usedVersion,
                        region,
                        productGroup: usedProductGroup,
                        productFamily: kmatId,
                        tabCategory: selectedCategory,
                    },
                };
            }
        } else if (isServices) {
            apiParams = { filter: { pkIds, whoChanged, moduleType, productFamily: kmatId  } };
        } else  {
        apiParams = { filter: { pkIds, whoChanged, moduleType } };
        }
    } else if (isComplete) {
        if(isMaterial){
            const hasCheckedRows = checkedRows?.length !== 0;
            apiParams = {
                    input: {
                        pkId: hasCheckedRows ? pkIds : [],
                        whoChanged,
                        version: usedVersion,
                        region,
                        productGroup: usedProductGroup,
                        productFamily: kmatId,
                        tabCategory: selectedCategory,
                    },
                };
        } else if (isServices) {
            apiParams = { input: {  pkId: pkIds, whoChanged , productFamily: kmatId  } };
        } else  {
            apiParams = { input: { pkId: pkIds, whoChanged } };
        }
    }

    try {
        const res = await GraphqlApi.query(apiMethod, apiParams);
        const { response, message } = res?.data?.[apiMethod] || {};

        if (response === "Success") {
            dispatch({ type: DATA_TRANSPORT_AND_COMPLETE, payload: { dataTransport: response, loadCount: response, isLoading: false } });
            dispatch(snackBar(true, message, response?.toLowerCase()));
            if (isModel) 
                dispatch(modelAvailability(usedVersion, region, kmatId, productGroup, productLineID));
            if (isMaterial)
                dispatch(materialAvailability(usedVersion, region, productGroup, kmatId, selectedCategory , 0, 9999, "", "", "", true));
            if (isServices)
                    dispatch(factoryService(usedVersion, region, productGroup, kmatId, true));
            if (isLOCAvailability)
                dispatch(localizationAvailability(usedVersion, region, kmatId , usedProductGroup, true));
            if (isDefaultLOC)
                dispatch(localizationDefault(usedVersion, region, "", usedProductGroup, kmatId , true));
            if (isTOFPM)
                dispatch(getTOFProgramManagement(usedVersion, region, true));
            if (isLOCmapping)
                dispatch(getLocalizationMapping(usedVersion, region, true));
            if (isLOCCID)
                dispatch(getLocalizationChoiceId(usedVersion, region, true));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
        } else {
            dispatch({ type: DATA_TRANSPORT_AND_COMPLETE, payload: { dataTransport: null, loadCount: null, isLoading: false } });
            dispatch(snackBar(true, message ,"error"));
        }
    } catch (error) {
        dispatch({ type: DATA_TRANSPORT_AND_COMPLETE, payload: { dataTransport: null, loadCount: null, isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const dashboardDataTransport = (whoChanged, selectedItems = [], dataTransportObjs,setisLoading) => async (dispatch) => {
        setisLoading(true);
    try {
        const filteredModuleTypes = selectedItems
            .filter(type => type !== "Full Data Transport")
            .map(type => moduleTypeMap[type] || type);

        const { data: { dataTransport } } = await GraphqlApi.query('dataTransport', {
            filter: { whoChanged, moduleTypes: filteredModuleTypes, dataTransportObjs }
        });
        const { response, message } = dataTransport;

        if (response === "Success" ) {
            dispatch({ type: DATA_TRANSPORT_AND_COMPLETE, payload: response });
            dispatch(snackBar(true, message, response.toLowerCase()));
            dispatch(refreshOcplc());
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setisLoading(false);
        }
    } catch (error) {
        setisLoading(false);
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const createCopyAvailability = (formData,plcDetails, onClose, setCheckedRows, productLineID, kmatId ,setSelectedIds, selectedCategory, selectedTableRegion, productGroupDashboard) => async (dispatch) => {
    dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId:null, isLoading:true } });
    onClose()
    const data = {
        version: plcDetails.version,
        region: plcDetails.region,
        country: formData.countryID,
        businessModel: formData.businessModel,
        productLine: "",
        productGroup: plcDetails.productGroup,
        productFamily: plcDetails.productFamily,
        sltdProductFamily: kmatId,
        startDate: formData.startDate && formData.startDate.format() || "",
        endDate: formData.endDate && formData.endDate.format() || "",
        apRegion: formData.ap,
        euRegion: formData.eu,
        naRegion: formData.na,
        laRegion: formData.la,
        whoChanged: formData.whoChanged,
        comments: formData.comment,    
        material: plcDetails.material,
        choiceId: plcDetails.choiceId ,
        localization: formData.localization,
        regionLock: formData.regionalLock || false,
        autoStart: formData.autoStartDate?.format() || "",
        autoEnd: formData.autoEndDate?.format() || "",
    };
    try {
        const res = await GraphqlApi.query('createMaterialAvailability', { input: data });

        const response = res?.data?.createMaterialAvailability;

        if (response?.message === 'Success') {
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {...response, isLoading:false } });
            dispatch(filterOcplcKmat(productLineID));
            dispatch(snackBar(true, `Material data for ${response.productFamily} copied successfully`, 'success'));
            dispatch(materialAvailability(plcDetails.version, selectedTableRegion, productGroupDashboard, kmatId, selectedCategory, 0, 9999, "", "", "", true));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setCheckedRows([]);
            setSelectedIds([]);
        }
    } catch (error) {
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: {pkId:null, isLoading:false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const copyRegionForMaterialAvailability = (formData, plcDetails, onClose, setCheckedRows, productLineID, kmatId, setSelectedIds,selectedCategory, selectedTableRegion, productGroupDashboard) => async (dispatch) => {
    dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId:null, isLoading:true } });
    onClose()
    const data = {
        Editmaterial: [
            {
                pkId: 0,
                version: plcDetails.version,
                region: formData.region,
                country: formData.countryID || "ALL",
                countryDesc: formData.countryDesc || "",
                businessGroup: plcDetails.businessGroup,
                businessModel: formData.businessModel || "ALL",
                productGroup: plcDetails.productGroup,
                productFamily: plcDetails.productFamily,
                sltdProductFamily: kmatId,
                material: plcDetails.material,
                materialDesc: plcDetails.materialDesc || "",
                localization: formData.localization || "ALL",
                choiceId: plcDetails.choiceId || "",
                apRegion: formData.apRegion || false,
                euRegion: formData.euRegion || false,
                naRegion: formData.naRegion || false,
                laRegion: formData.laRegion || false,
                autoStartDate: formData.autoStartDate?.format() || "",
                startDate: formData.regStartDate && formData.regStartDate?.format() || "",
                startFlag: "",
                endDate: formData.regEndDate && formData.regEndDate?.format() || "",
                endFlag: "",
                autoEndDate: "",
                hStartDate: formData.hStartDate?.format() || "",
                hEndDate: formData.hEndDate?.format() || "",
                comments: formData.comment || "",
                status: formData.status || "M",
                regionLock: formData.regionLock || false,
                logicalLock: 0,
                whoChanged: formData.whoChanged || "",
                lastModifiedDate: "",
                createDate: "",
                keyOrder: 0,
                errorFlag: "",
                tofWhoChanged: "",
                tofWhenChanged: "",
                wwStartDate: formData.wwStartDate?.format() || "",
                wwEndDate: formData.wwEndDate?.format() || "",
            }
        ]
    };
    regionalFields.forEach(({ startField, startName, endField, endName }) => {
        data.Editmaterial[0][startName] = plcDetails[startName];
        data.Editmaterial[0][endName] = plcDetails[endName];
        data.Editmaterial[0][startField] = formData[startField] && formData[startField]?.format() || "";
        data.Editmaterial[0][endField] = formData[endField] && formData[endField]?.format() || "";
    });

    try {
        const res = await GraphqlApi.query("copyRegionForMaterialAvailability", { input: data });
        const response = res?.data?.createRegionalMaterialAvailability;
        const {pkId, status, createDate, lastModifiedDate} = response || {};
        if (response?.message === "Success") {
            dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { ...data.Editmaterial[0], pkId, status, createDate, lastModifiedDate,isLoading:false } });
            dispatch(materialAvailability(plcDetails.version, selectedTableRegion, productGroupDashboard, kmatId, selectedCategory, 0, 9999, "", "", "", true));
            dispatch(snackBar(true, `Material data for ${plcDetails.productFamily} copied successfully`, "success"));
            clearLocalStorageKey(LOCAL_STORAGE_KEY);
            setCheckedRows([]);
            setSelectedIds([]);
        }
    } catch (error) {
        dispatch({ type: CREATE_EXISTING_AVAILABILITY, payload: { pkId:null, isLoading: false } });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const downloadOcplcAction = (checkedRows = [], productLineID, setCheckedRows, handleClose, region, selectKmat = [], title, selectedTable, tableRegions = [], selectedCategory, productGroup, selectedProductGroup,setisLoading, setSelectedIds) => async (dispatch) => {
    const isDashboard = title === DASHBOARD_TITLE;
    const isMaterial = selectedTable === MATERIAL_AVAILABILITY;
    const isModel = selectedTable === MODEL_AVAILABILITY_TABLE;
    const isService = selectedTable === FACTORY_SERVICES;
    const isDefaultLOC = selectedTable === DEFAULT_LOC;
    const isLOCAvailability = selectedTable === LOC_AVAILABILITY;
    const isTOFPM = selectedTable === TOF_PROGRAM_MANAGEMENT;
    const isParameterChoice = selectedTable === LOC_CHOICE_ID;
    const isParameterMapping = selectedTable === LOC_MAPPING;

    const productFamilyList = extractAndJoin(checkedRows, 'kmatId');
    const productLineList = extractAndJoin(checkedRows, 'productLineID');
    const productGroupList = extractAndJoin(checkedRows, 'productGroup');
    const pkIds = checkedRows.map(row => row.pkId);

    // Check for different product lines in dashboard download
    if (isDashboard) {
        const uniqueProductLines = [...new Set(checkedRows.map(row => row.productLineID))];
        if (uniqueProductLines.length > 1) {
            dispatch(
                snackBar(
                    true,
                    "You can't download these Product Families because you selected different Product Lines.",
                    "error"
                )
            );
            return;
        }
    }

    try {
        setisLoading(true);
        handleClose();
        let res;
        if (isDashboard) {
            // filter for dashboard download
            res = await GraphqlApi.query("getDashboardDownload", {
                filter: {
                    productFamily: productFamilyList,
                    productLine: productLineList,
                    productGroup: productGroupList,
                    TableRegions: tableRegions
                }
            });
        } else {
            //  input for table downloads
            const apiMethod = isMaterial
              ? "downloadMaterialAvailability"
              : isModel
              ? "downloadModelAvailability"
              : isService
              ? "downloadServiceAvailability"
              : isDefaultLOC
              ? "downloadLocalizationDefault"
              : isLOCAvailability
              ? "downloadLocalizationAvailability"
              : isTOFPM
              ? "downloadTOFPM"
              : isParameterChoice
                ? "downloadParameterChoice"
                : isParameterMapping
                ? "downloadParametersLOCMapping"
              : "";

            const selectedRecord = checkedRows[0];
            const hasKmat = selectKmat.length > 0;

           const filter = {
                version: selectedRecord?.version,
                region,
                pkId: pkIds,
                ...(isTOFPM || isParameterChoice || isParameterMapping ? {} : { productFamily: hasKmat ? selectKmat : "" }),
                productGroup:   (isDefaultLOC || isLOCAvailability) ? selectedProductGroup : productGroup,

                   // Only send productLine if not material and not service
                ...(!isMaterial && !isService && {
                    productLine: productLineID,
                }),

                ...(isMaterial && {
                    category: selectedCategory || "",
                    material: "",
                }),
                ...(isDefaultLOC && {
                    bussGroup: selectedRecord?.businessGroup || "",
                }),
            };

            res = await GraphqlApi.query(apiMethod, { filter });

        }

        let name, content;
        if (isDashboard) {
            ({ name, content } = res?.data?.dashboardDownload || {});
        } else if (isMaterial) {
            ({ name, content } = res?.data?.DownloadMaterial || {});
        } else if (isService) {
            ({ name, content } = res?.data?.DownloadServiceAvailability || {});
        } else if (isDefaultLOC) {
            ({ name, content } = res?.data?.downloadLocalizationDefault || {});
        } else if (isLOCAvailability) {
            ({ name, content } = res?.data?.downloadLocalizationAvailability || {}); 
        } else if (isTOFPM) {
            ({ name, content } = res?.data?.tofProgramsManagementDownload || {});
        } else if (isParameterChoice) {
            ({ name, content } = res?.data?.downloadparameterLocalizationChoice || {});
        } else if (isParameterMapping) {
            ({ name, content } = res?.data?.downloadParameterLocalization || {});
        } else {
            ({ name, content } = res?.data?.modelDownload || {});
        }



        if (!name || !content) {
            throw new Error(
                `Failed to download file for ${
                    isDashboard
                        ? "Dashboard"
                        : isMaterial
                            ? "Material" : isModel
                            ? "Model"
                            : isDefaultLOC
                            ? "Default Localization"
                            : isLOCAvailability
                            ? "Available Localization"
                            : isTOFPM
                            ? "TOF Program Management"    
                            : isParameterChoice
                            ? "Localization Choice ID Customization"
                            : isParameterMapping
                            ? "Localization Mapping"
                            : "Service"
                } Availability`
            );
        }

        const u8arr = u8arrFromBase64EncodedString(content);
        const file = new File([u8arr], name);
        fileDownload(file, name);
        setCheckedRows([]);
        setSelectedIds([]);

        const successMsg = isDashboard
          ? "Dashboard file generated successfully"
          : `${
              isMaterial
                ? "Material"
                : isModel
                ? "Model"
                : isService
                ? "Service"
                : isDefaultLOC
                ? "Default Localization"
                : isLOCAvailability
                ? "Available Localization"
                : isTOFPM
                ? "TOF Program Management"
                : isParameterChoice
                ? "Localization Choice ID Customization"
                : isParameterMapping
                ? "Localization Mapping"
                : ""
            } Availability file generated successfully`;

        dispatch(snackBar(true, successMsg, "success"));
        setisLoading(false)
    } catch (error) {
        dispatch(snackBar(true, error.message, "error"));
        setisLoading(false)
    }
};

export const LockAndDownloadAction = (checkedRows = [], handleDialogClose, setCheckedRows, region, loginUserEmailId, selectedCategory, selectKmat, productGroup, setSelectedIds, setisLoading) => async (dispatch) => {
    const selectedRecord = checkedRows[0];
    const hasKmat = selectKmat.length > 0;
    try {   
        setisLoading(true);
        handleDialogClose();
        const { pkIds, regions } = checkedRows.reduce(
          (acc, row) => {
            acc.pkIds.push(row.pkId);
            acc.regions.push(row.region);
            return acc;
          },
          { pkIds: [], regions: [] }
        );
        const res = await GraphqlApi.query('LockAndDownloadMaterial', {
            filter: {
                version: selectedRecord?.version || "",
                region: region,
                recordRegions: regions,
                productGroup:  productGroup,
                category: selectedCategory || "",
                productFamily: hasKmat ? selectKmat : "",
                material:  "",
                whoChanged: loginUserEmailId,
                pkId: pkIds
            }
        });

        const { name, content } = res?.data?.lockAndDownloadMaterial || {};

        const u8arr = u8arrFromBase64EncodedString(content);
        const file = new File([u8arr], name);
        fileDownload(file, name);
        setCheckedRows([]);
        setSelectedIds([])

        const successMsg = "Material Availability file generated and locked successfully";

        dispatch(snackBar(true, successMsg, "success"));
        dispatch(materialAvailability(selectedRecord.version, region, productGroup, selectKmat, selectedCategory, 0, 9999, "", "", "", true));
        setisLoading(false);
    } catch (error) {
        dispatch(snackBar(true, error.message, "error"));
        setisLoading(false);
    }
};

export const filterOcplcKmatforPG = (productGroup, loginUserEmailId) => async (dispatch) => {
    try {
        const res = await GraphqlApi.query("filterOcplcKmatforPG", { filter: { productGroup, loginUserEmailId } });
        const kmatList = res?.data?.getKmatsForPg?.kmatIds || [];
        dispatch({ type: FILTER_OCPLC_KMAT_FOR_PG, payload: kmatList });
    } catch (error) {
        dispatch({ type: FILTER_OCPLC_KMAT_FOR_PG, payload: [] });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const ocplcUploadFile = (fileObj, checkedRows, selectedCategory, selectKmat, productGroup, region, setCheckedRows,handleClose,setSelectedIds) => async (dispatch) => {
    try {
        dispatch({ type: UPLOAD_LAND_D_FILE, payload: {isLoading:true}});
        handleClose();
        // Prepare FormData for file upload
        const formData = new FormData();
        formData.append('operations', JSON.stringify({
            query: queries['ocplcUploadFile'],
            variables: { file: null }
        }));
        formData.append('map', JSON.stringify({ "0": ["variables.file"] }));
        formData.append('0', fileObj);

        // Use axios directly for multipart upload
        const res = await GraphqlApi.instance.post('model', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        const uploadFile = res?.data?.uploadFile;

        dispatch({ type: UPLOAD_LAND_D_FILE, payload: {uploadFile,isLoading:false}});
        setCheckedRows([]);
        setSelectedIds([]);

        dispatch(snackBar(true, `File uploaded successfully`, "success"));
        dispatch(materialAvailability(checkedRows[0].version, region, productGroup, selectKmat, selectedCategory, 0, 9999, "", "", "", true));
    } catch (error) {
        dispatch(snackBar(true, error.message, "error"));
        dispatch({ type: UPLOAD_LAND_D_FILE, payload: {isLoading:false}});
    }
};

export const getRegionalCheckBox = (pkId) => async (dispatch) => {
    try {
        dispatch({ type: GET_REGIONAL_CHECKBOXES, payload: {}, isLoading: true });
        const res = await GraphqlApi.query("regionalChecklist", { filter: {  pkId } });
        const regions = res?.data?.getRegionalCheckBox || {};
        dispatch({ type: GET_REGIONAL_CHECKBOXES, payload: regions, isLoading: false });
    } catch (error) {
        dispatch({ type: GET_REGIONAL_CHECKBOXES, payload: {}, isLoading: false });
        dispatch(snackBar(true, error.message, "error"));
    }
};
